<template>
  <div>
    <div class="titles">
      编辑权限
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>

    <Scroll height="700" class="hideGd" v-loading="loadings">
      <CheckboxGroup v-model="border">
        <Collapse v-model="value1">
          <Panel :name="value1[index]" v-for="(item,index) in data" :key="index">
            {{item.name}}
            <div class="qx01" slot="content">
              <Checkbox class="" :label="''+items.id+'#'+items.pid+''" v-for="(items,indexs) in item.sonList" :key="indexs" border>{{items.name}}</Checkbox>
            </div>
          </Panel>
        </Collapse>
      </CheckboxGroup>
      <Button class="role04" type="primary" icon="ios-add" @click="addRoles" :loading="loading">确定</Button>
    </Scroll>
  </div>
</template>

<script>
  import httpAuth from '@/api/auth';
  import httpRole from '@/api/role';
  export default {
    name: "addRole",
    data(){
      return{
        value1: [],           //权限下标
        data:[],              //权限列表
        border:[],            //选中的数据
        loading:false,        //按钮是否加载
        roleId:'',            //传递过来的角色ID
        loadings:true,        //是否加载权限列表数据
      }
    },
    created() {
      var lett = this;
      if (lett.$route.params.hasOwnProperty('roleId')) {
        lett.roleId = lett.$route.params.roleId;
      }
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.addRoles();
        }
      }
    },
    mounted() {
      //获取当前所有权限
      var me = this;
      me.loadings = true;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        userId:user.id,
        sign:user.sign,
        mobile:user.mobile,
        companyId:user.companyId
      };
      let inter;
      if (user.companyId != '1') {
        data['roleId'] = 1;
        inter = httpAuth.authListRole(data);
      } else {
        inter = httpAuth.authList(data);
      }
      inter.then(res => {
        console.log(res);
        switch (res.code) {
          case "0000":
            me.data = res.data;
            me.data.forEach(function (item,index) {
              me.value1.push(''+index+'');
            })
            me.loadings = false;
            break;
          default:
            me.$message.error('系统错误');
            break;
        }
      })
      let datas = {
        roleId:me.roleId,
        companyId:user.companyId,
        mobile:user.mobile,
        sign:user.sign
      }
      httpRole.roleAuthList(datas).then(res => {
        console.log(res.data);
        res.data.forEach(function (item,index) {
          item.sonList.forEach(function (items,indexs) {
            let str = ''+items.id+'#'+item.id+''
            me.border.push(str);
          })
        })
      })
    },
    methods:{
      back(){
        var me = this;
        me.$router.back();
      },
      addRoles(){//添加角色
        var me = this;
        if (me.border.length === 0) {
          me.$message.error('至少选择一个权限');
          return false;
        }
        me.loading = true;
        me.$Loading.start();
        let qx = me.border.join('#');
        // console.log(me.roleId);return false;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          permissionIds: qx,
          mobile: user.mobile,
          companyId: user.companyId,
          sign: user.sign,
          roleId:me.roleId
        }
        httpRole.editRoleAuth(data).then(res => {
          if (res.code == "0000") {
            me.loading = false;
            me.$Loading.finish();
            me.$message.success("编辑成功");
            setTimeout(function () {
              me.$router.back();
            },1500);
          } else {
            me.loading = false;
            me.$Loading.error();
            me.$message.error('编辑失败');
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "roleList.css";
</style>